import { render, staticRenderFns } from "./Inheritance.vue?vue&type=template&id=e0917990&scoped=true"
import script from "./Inheritance.vue?vue&type=script&lang=js"
export * from "./Inheritance.vue?vue&type=script&lang=js"
import style0 from "./Inheritance.vue?vue&type=style&index=0&id=e0917990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0917990",
  null
  
)

export default component.exports